module.exports = __webpack_public_path__ + "img/hj.ad0c95d4.png";